import { SubscriptionInfoResponse } from 'services/api/responses/responseTypes';
import type { ISubscriptionInfo } from './iSubscriptionInfo';

export default class SubscriptionInfo implements ISubscriptionInfo {
  id: string;

  paymentDetails: {
    last4: number;
  };

  period: {
    start: {
      date: Date;
      timezoneType: number;
      timezone: string;
    };
    end: {
      date: Date;
      timezoneType: number;
      timezone: string;
    };
  };

  price: {
    currency: string;
    unitAmount: number;
  };

  product: {
    id: string;
    name: string;
  };

  recurring: {
    interval: 'month' | 'year';
    intervalCount: number;
  };

  status: string;

  constructor(data: SubscriptionInfoResponse) {
    this.id = data.id;
    this.paymentDetails = data.payment_details;
    this.period = {
      start: {
        date: new Date(data.period.start.date),
        timezoneType: data.period.start.timezone_type,
        timezone: data.period.start.timezone,
      },
      end: {
        date: new Date(data.period.end.date),
        timezoneType: data.period.end.timezone_type,
        timezone: data.period.end.timezone,
      },
    };
    this.price = {
      currency: data.price.currency,
      unitAmount: data.price.unit_amount,
    };
    this.product = data.product;
    this.recurring = {
      interval: data.recurring.interval,
      intervalCount: data.recurring.interval_count,
    };
    this.status = data.status;
  }
}
